import { AxiosErrorHandler } from 'ui';
import { PublicEventSkeleton } from '../components';
import { useEventPublicQuery, useInvitationTokenQuery } from '../queries';
import { SharedProgramEventContent } from './shared-program-event-content';

type P = {
  eventId: string;
  invitationToken: string;
};

const PublicSharedProgramEvent = ({ eventId, invitationToken }: P) => {
  const {
    data: eventContentObject,
    error: eventError,
    isFetching: isFetchingEvent,
    isLoading: isLoadingEvent,
  } = useEventPublicQuery({ eventId, invitationToken }, { throwOnError: false });

  const {
    data: invitationTokenData,
    error: tokenError,
    isFetching: isFetchingInvitationToken,
    isLoading: isLoadingInvitationToken,
  } = useInvitationTokenQuery({ invitationToken }, { throwOnError: false });

  return (
    <AxiosErrorHandler error={eventError ?? tokenError}>
      {isLoadingEvent ||
      isFetchingEvent ||
      isFetchingInvitationToken ||
      isLoadingInvitationToken ||
      !eventContentObject ||
      !invitationTokenData ? (
        <PublicEventSkeleton />
      ) : (
        <SharedProgramEventContent eventContentObject={eventContentObject} invitationToken={invitationTokenData} />
      )}
    </AxiosErrorHandler>
  );
};

export default PublicSharedProgramEvent;
